/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '@angular/router';
import * as import2 from '../../../app/company-view/company-view.component';
const styles_CompanyViewComponent:any[] = ([] as any[]);
export const RenderType_CompanyViewComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_CompanyViewComponent,
  data: {}
}
);
export function View_CompanyViewComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),7,'main',[[
        'class',
        'main'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'container'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵeld(16777216,(null as any),(null as any),1,'router-outlet',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(147456,(null as any),0,import1.RouterOutlet,[
      import1.RouterOutletMap,
      import0.ViewContainerRef,
      import0.ComponentFactoryResolver,
      [
        8,
        (null as any)
      ]

    ]
    ,(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(null as any),(null as any));
}
function View_CompanyViewComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'app-main',([] as any[]),(null as any),(null as any),(null as any),View_CompanyViewComponent_0,RenderType_CompanyViewComponent)),
    import0.ɵdid(114688,(null as any),0,import2.CompanyViewComponent,([] as any[]),(null as any),(null as any))
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(null as any));
}
export const CompanyViewComponentNgFactory:import0.ComponentFactory<import2.CompanyViewComponent> = import0.ɵccf('app-main',import2.CompanyViewComponent,View_CompanyViewComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3N0b3JhZ2Uvdmhvc3QvcGFuZWwuZGF0YXNwYWNlLnBsL3dlYi9kYXRhc3BhY2UtY3AtZHMtZnJvbnQvc3JjL2FwcC9jb21wYW55LXZpZXcvY29tcGFueS12aWV3LmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9zdG9yYWdlL3Zob3N0L3BhbmVsLmRhdGFzcGFjZS5wbC93ZWIvZGF0YXNwYWNlLWNwLWRzLWZyb250L3NyYy9hcHAvY29tcGFueS12aWV3L2NvbXBhbnktdmlldy5jb21wb25lbnQudHMiLCJuZzovLy9zdG9yYWdlL3Zob3N0L3BhbmVsLmRhdGFzcGFjZS5wbC93ZWIvZGF0YXNwYWNlLWNwLWRzLWZyb250L3NyYy9hcHAvY29tcGFueS12aWV3L2NvbXBhbnktdmlldy5jb21wb25lbnQuaHRtbCIsIm5nOi8vL3N0b3JhZ2Uvdmhvc3QvcGFuZWwuZGF0YXNwYWNlLnBsL3dlYi9kYXRhc3BhY2UtY3AtZHMtZnJvbnQvc3JjL2FwcC9jb21wYW55LXZpZXcvY29tcGFueS12aWV3LmNvbXBvbmVudC50cy5Db21wYW55Vmlld0NvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxtYWluIGNsYXNzPVwibWFpblwiPlxuICAgIDxkaXYgY2xhc3M9XCJjb250YWluZXJcIj5cbiAgICAgICAgPHJvdXRlci1vdXRsZXQ+PC9yb3V0ZXItb3V0bGV0PlxuICAgIDwvZGl2PlxuPC9tYWluPiIsIjxhcHAtbWFpbj48L2FwcC1tYWluPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O01DQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtJQUFtQjtNQUNmO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFBdUI7SUFDbkI7Z0JBQUE7Ozs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7SUFBQTtLQUFBO0lBQStCO0lBQzdCOzs7Ozs7SUNIVjtnQkFBQTs7O0lBQUE7OzsifQ==



// WEBPACK FOOTER //
// ./src/$$_gendir/app/company-view/company-view.component.ngfactory.ts